// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"e4446e3e","450":"3bb13c97","648":"fa2072f1","807":"9a923173","817":"d3aca799","973":"fb6fa3a2"}[chunkId] + ".chunk.js";
};